import styled from 'styled-components'

import { ButtonLinkProps } from '@customTypes'

import { getButtonStyle } from './components/button-style'
import { getEdgeRadius } from './components/edge-radius'

export const ButtonLink = styled.a<ButtonLinkProps>`
  ${getButtonStyle}
  border-radius: ${getEdgeRadius};
`
